// カートページのUI制御・フォーム管理を担う。
// カートアイテムの数量変更・削除は cart.js が担当する。
//
// 本体サイト (mrc-web) の cart-page.js から、lottery で使わない
// カート自動修正・温度帯・アイス・周年eチケットを除いたもの。
//
// このファイルの主な責務:
// - 抽選申込ボタン (name="checkout") の活性/非活性を、配送日時・eギフト入力状態から判定する
// - カートページ固有の UI（配送日、eギフト、オプション商品、送り主名）を初期化する
//
// 外部依存（cart.liquid のscript読み込み順で、すべてこのファイルより先に読み込まれる）:
// - window.CART_DATA: sections/cart.liquid が出力するカート状態
// - window.CartAPI: assets/cart.js が公開する Shopify Ajax API ラッパー
// - window.cartUpdateAndReload: assets/cart.js が公開する更新後リロード関数
// - dateToStr12H: assets/e-gift.js が公開する日付フォーマッタ
// - jQuery / jQuery UI datepicker / Slick

$(function () {
  // CART_DATA は Liquid 由来なので、JS 側では常に欠損に耐える形で読む。
  const cartData = window.CART_DATA || {};
  const $checkoutButton = $('[name="checkout"]');
  // Liquid 側ですでに disabled なケース（強制販売停止・購入制限など）は JS で勝手に解除しない。
  const isStaticCheckoutDisabled = $checkoutButton.prop("disabled");

  // Shopify Ajax API へのアクセスは cart.js の CartAPI に集約する（実装を二重に持たない）。
  const CartAPI = window.CartAPI;

  // cart.js の既存リロード戦略（cartUpdateAndReload）でページを再同期する。
  const reloadCart = (cart) => {
    const productTypes = cart && Array.isArray(cart.items)
      ? cart.items.map((item) => item.product_type)
      : [];

    window.cartUpdateAndReload(productTypes);
  };

  // イベントハンドラから呼ぶ唯一の checkout 更新入口。
  const refreshCheckoutButton = (canCheckout) => {
    if (!$checkoutButton.length || isStaticCheckoutDisabled) {
      return;
    }

    $checkoutButton.toggleClass("disable", !canCheckout);
  };

  const hasDeliveryDateTime = () => {
    return $("#delivery_time").val() !== "" && $("#delivery_date").val() !== "";
  };

  const refreshDeliveryDatePicker = () => {
    const $datepicker = $("#datepicker");
    if (typeof $.fn.datepicker === "function" && $datepicker.hasClass("hasDatepicker")) {
      $datepicker.datepicker("refresh");
    }
  };

  // タグ[配送日選択不可, eギフト選択不可]を両方持つ商品がある場合、購入方法の選択を出さない。
  const initHowToBuy = () => {
    if (cartData.isHideHowToBuy) {
      $(".form__how-to-buy").hide();
    }
  };

  // 配送日/配送時間入力を初期化する。
  // datepicker が読み込まれていない場合でも、他のカート機能は動かす。
  const initDeliveryDatePicker = () => {
    const $datepicker = $("#datepicker");
    $(".order-delivery").hide();
    if (!$datepicker.length) {
      return;
    }

    $("[name='fix-date']").on("click", function () {
      const fixDateValue = $(this).val();
      if (fixDateValue === "none-fix-date") {
        $(".order-delivery").hide();
        $("#delivery_date").val("");
        $("#delivery_youbi").val("");
        $("#delivery_time").val("");
        refreshDeliveryDatePicker();
        refreshCheckoutButton(true);
      } else if (fixDateValue === "fix-date") {
        $("#delivery_date").val($("#tmp_delivery_date").val());
        $("#delivery_youbi").val($("#tmp_delivery_youbi").val());
        $("#delivery_time").val($("#tmp_delivery_time").val());
        refreshDeliveryDatePicker();
        $(".order-delivery").show();
        refreshCheckoutButton(hasDeliveryDateTime());
      }
    });

    $("[name='delivery_time']").on("change", function () {
      const fixTimeValue = $(this).val();
      $("#delivery_time").val(fixTimeValue);
      $("#tmp_delivery_time").val(fixTimeValue);
      refreshCheckoutButton(hasDeliveryDateTime());
    });

    if (typeof $.fn.datepicker !== "function") {
      return;
    }

    // 注文属性「曜日」はメールテンプレート側の置換に合わせて英語曜日で保存する。
    const weekStr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    // 配送可能日の範囲はセクション設定（配送指定日）から受け取る。
    const minDate = new Date(cartData.deliveryMinDate);
    const maxDate = new Date(cartData.deliveryMaxDate);
    const dateFormat = "yy/mm/dd";
    const disableDates = [];

    $datepicker.datepicker({
      minDate,
      maxDate,
      dateFormat,
      defaultDate: null,
      onSelect(dateText) {
        $("#delivery_date").val(dateText);
        $("#tmp_delivery_date").val(dateText);

        const selectedDate = new Date(dateText);
        $("#delivery_youbi").val(weekStr[selectedDate.getDay()]);
        $("#tmp_delivery_youbi").val(weekStr[selectedDate.getDay()]);
        refreshCheckoutButton(hasDeliveryDateTime());
      },
      beforeShowDay(date) {
        const disableDate = $.datepicker.formatDate(dateFormat, date);
        const isAvailable = disableDates.indexOf(disableDate) === -1;
        const isSelected = isAvailable && disableDate === $("#delivery_date").val();
        return [isAvailable, isSelected ? "is-delivery-date-selected" : "", ""];
      },
    });

    $datepicker.addClass("notranslate");
  };

  // eギフト受け取り期限を「購入日から14日後」として表示する。
  // 日付フォーマットは e-gift.js の dateToStr12H に集約する。
  const initEgiftLimitDate = () => {
    if (!$("#limited_date").length) {
      return;
    }

    const limitDate = new Date();
    limitDate.setDate(limitDate.getDate() + 14);
    $("#limited_date").text(dateToStr12H(limitDate, "Y年M月D日（W）"));
  };

  // eギフトカードデザインの Slick スライダーを初期化し、選択中カードIDを hidden input に同期する。
  const initEgiftSlider = () => {
    const $slide = $(".slide");
    if (!$slide.length || typeof $.fn.slick !== "function") {
      return;
    }

    $slide.on("init", function () {
      const activeSlide = $(this).find(".slick-active");
      $("#card-label").text(activeSlide.attr("data-label"));
    });

    const mainSlick = $slide.slick({
      variableWidth: true,
      centerPadding: "0",
      slidesToShow: 1,
      infinite: true,
      centerMode: true,
      autoplay: false,
      arrows: true,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0036/3721/5277/files/arrow-left.png?v=1638237387" class="slide-arrow prev-arrow">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0036/3721/5277/files/arrow-right.png?v=1638237387" class="slide-arrow next-arrow">',
    });

    mainSlick.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      mainSlick.find(".slick-slide").each((index, el) => {
        const $this = $(el);
        const slickIndex = $this.attr("data-slick-index");
        if (nextSlide === slick.slideCount - 1 && currentSlide === 0) {
          $this.toggleClass("is-active-next", slickIndex === "-1");
        } else if (nextSlide === 0) {
          $this.toggleClass("is-active-next", slickIndex == slick.slideCount);
        } else {
          $this.removeClass("is-active-next");
        }
      });
    });

    mainSlick.on("afterChange", function () {
      const activeSlide = $(this).find(".slick-active");
      $("#card-label").text(activeSlide.attr("data-label"));
      $("#card-id").val(activeSlide.attr("data-id"));
    });
  };

  // オプション商品（ギフトバッグ）の追加/解除をカートに反映する。
  const initGiftBagOptions = () => {
    $(".form__option input:radio").on("change", async function () {
      const bagQuantity = $(this).val();
      const bagId = $(".form__with-option .option_quantity").attr("variant-id");
      if (!bagId) {
        return;
      }

      try {
        const cart = await CartAPI.updateCart({ [bagId]: bagQuantity });
        reloadCart(cart);
      } catch (error) {
        console.error("Gift bag update failed:", error);
        window.location.reload();
      }
    });
  };

  // 配送伝票用の送り主名入力を制御する。
  const initSenderName = () => {
    $('[name="cart_options[fromname]"]:radio').on("change", function () {
      if ($("#form__none-fromname").prop("checked")) {
        $('[name="attributes[from-name]"]').val("");
        $(".form__with-fromname").hide();
      } else {
        $(".form__with-fromname").show();
      }
    });

    $('[name="attributes[from-name]"]').on("load keyup", function () {
      const text = $('[name="attributes[from-name]"]').val();
      if (text && text.length > 10) {
        $('[name="attributes[from-name]"]').val(text.slice(0, 10));
      }
    });
  };

  // Slick 上で現在選択されているeギフトカードIDを取得する。
  const getActiveEgiftCardId = () => {
    return $(".slide").find(".slick-active").attr("data-id") || "";
  };

  // 通常配送に戻した時、eギフト専用の注文属性が checkout に残らないように消す。
  const resetEgiftAttributes = () => {
    $('[name="attributes[egift-fromname]"]').val("");
    $('[name="attributes[egift-dearname]"]').val("");
    $('[name="attributes[egift-message]"]').val("");
    $('[name="attributes[egift-card-id]"]').val("");
    $('[name="attributes[egift-receive]"]').val("");
  };

  // 通常配送/eギフトの切り替えと、eギフト入力に応じた checkout 制御を担当する。
  const initEgiftForm = () => {
    $(".form__e-gift-option-wrapper").hide();

    $('[name="attributes[egift]"]:radio').on("change", function () {
      if ($("#form__none-egift").prop("checked")) {
        $(".form__e-gift-option-wrapper").hide();
        $(".form__fix-date-wrapper").show();

        if ($("#form__none-fix-date").prop("checked")) {
          refreshCheckoutButton(true);
        } else {
          $("#delivery_date").val($("#tmp_delivery_date").val());
          $("#delivery_time").val($("#tmp_delivery_time").val());
          $("#delivery_youbi").val($("#tmp_delivery_youbi").val());
          refreshCheckoutButton(hasDeliveryDateTime());
        }

        refreshDeliveryDatePicker();
        resetEgiftAttributes();
        return;
      }

      if ($("#form__with-egift").prop("checked")) {
        $(".uiDeliveryDateVal,.uiDeliveryDayVal,.uiDeliveryTimeVal").removeAttr("value");
        $("#delivery_date").val("");
        $("#delivery_youbi").val("");
        $("#delivery_time").val("");

        refreshDeliveryDatePicker();
        $("#egift-param").html(`
          <input type="hidden" id="card-id" name="attributes[egift-card-id]" value="">
          <input type="hidden" name="attributes[egift-receive]" value="yet">
        `);
        $("#card-id").val(getActiveEgiftCardId());

        $(".form__fix-date-wrapper").hide();
        $(".form__e-gift-option-wrapper").show();
        refreshCheckoutButton($('[name="attributes[egift-fromname]"]').val() !== "");

        if (typeof $.fn.slick === "function" && $(".slide").length) {
          $(".slide").slick("setPosition");
        }
      }
    });

    $('[name="attributes[egift-fromname]"]').on("keyup", function () {
      const maxLength = 20;
      const value = $(this).val();
      if (value && value.length >= maxLength) {
        $(this).val(value.slice(0, maxLength));
      }

      const hasFromName = $(this).val() !== "";
      refreshCheckoutButton(hasFromName);
      $(".e-gift-fromname-blank").toggle(!hasFromName);
      $(this).toggleClass("error", !hasFromName);
    });
  };

  // init関数の例外が他のinitやページ全体を道連れにしないよう、1つずつ隔離して実行する。
  const safeInit = (initFn) => {
    try {
      initFn();
    } catch (error) {
      console.error(`Cart page init failed: ${initFn.name}`, error);
    }
  };

  // 初期化順序:
  // 1. checkout判定に関わる配送UI
  // 2. eギフト表示とスライダー
  // 3. カート更新を伴うオプション商品
  // 4. 入力フォーム補助
  [
    initHowToBuy,
    initDeliveryDatePicker,
    initEgiftLimitDate,
    initEgiftSlider,
    initGiftBagOptions,
    initSenderName,
    initEgiftForm,
  ].forEach(safeInit);
});
